import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ViserVue from 'viser-vue'
import ELEMENT from 'element-ui'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import CodemaoSDK from '@/utils/iris'
import { colorRgb } from '@/utils/utils'
import VueLazyload from 'vue-lazyload'
import API from '@/utils/ajax'
import caReport from '@/utils/report'
import '@/utils/xss'
import { routerReport } from '@/utils/mixins'
import Directives from '@/utils/directive'
import TextWithTip from '@/components/truncateTextWithTip'
import '@/utils/sensor'
import { WebMonitor } from '@frontend/web-monitor'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

Vue.mixin(routerReport)

Vue.use(Directives)
Vue.use(ELEMENT, { size: 'mini' })
Vue.use(ViserVue)
Vue.use(CodemaoSDK)
Vue.use(VueLazyload, {
  preLoad: 1.5,
  error: '',
  loading: 'https://public-static-edu.codemao.cn/redboat/static/zhanwei.png',
  attempt: 1
})
Vue.use(caReport)
Vue.component('text-with-tip', TextWithTip)

window.API = API
// momentjs 的替代品 https://github.com/iamkun/dayjs
dayjs.extend(isBetween)
window.moment = dayjs

Vue.config.devtools = true

Sentry.init({
  Vue,
  dsn: 'https://48e4be79c522489a84ca50ad5a8ac16f@sentry.codemao.cn/161',
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      // tracingOrigins: ['localhost', 'test-teacher-edu.codemao.cn', 'teacher.edu.codemao.cn', /^\//]
      tracingOrigins: ['localhost', 'test-teacher-edu.codemao.cn', 'teacher-edu.codemao.cn', /^\//]
    })
  ],
  tracesSampleRate: 1.0
})

export default new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    // 这里告知puppeteer页面完毕，用于预渲染
    console.log('prerender event')
    document.dispatchEvent(new Event('render-event'))
  },
  watch: {
    // 检测是否定制教室设置标题及主题色
    '$store.state.customInfo': {
      handler(val) {
        const themeColor = val ? val.inner_theme_color : null
        document.documentElement.style.setProperty(
          '--primary-color-source',
          colorRgb(themeColor || '#00c4aa') // 默认主题色 #00c4aa
        )
        document.documentElement.style.setProperty(
          '--primary-color',
          'rgba(var(--primary-color-source), 1)'
        )

        document.documentElement.style.setProperty(
          '--primary-el-color-source',
          colorRgb(themeColor || '#FFA21C') // 默认elment相关按钮主题色 #ffc81d
        )
        document.documentElement.style.setProperty(
          '--primary-el-color',
          'rgba(var(--primary-el-color-source), 1)'
        )
        if (val) {
          document.title = val.name
        } else {
          document.getElementById('favicon').href =
            'https://education.codemao.cn/27/public-edu/1/favicon.ico'
        }
      },
      immediate: true
    }
  }
}).$mount('#app')

// 接入性能监控平台
try {
  // eslint-disable-next-line no-new
  new WebMonitor() // 默认不用传参
} catch (error) {
  console.log(error)
}
